import { Checkbox } from '@chakra-ui/react';
import dayjs from 'dayjs';
import React from 'react';

const GroupDetailTable = ({
  setCheckedItems,
  checkedItems,
  idList,
  searchList,
}) => {
  const CheckAll = e => {
    setCheckedItems(e.target.checked ? idList : []);
  };

  const CheckEach = (e, id) => {
    if (e.target.checked) {
      setCheckedItems([...checkedItems, id]);
    } else {
      setCheckedItems(checkedItems.filter(item => item !== id));
    }
  };

  return (
    <table className="MemberCustomTableStyle">
      <thead>
        <tr className="MemberCustom-tr MemberCustom-thead-tr">
          <th className="MemberCheckBox textCenter">
            <Checkbox
              name="all"
              value="all"
              colorScheme="blue"
              isChecked={checkedItems.length === idList.length}
              onChange={CheckAll}
            />
          </th>
          <th className="MemberCustom-th1 textLeft">회원명</th>
          <th className="MemberCustom-th2 textLeft">이메일주소</th>
          <th className="MemberCustom-th3 textCenter">가입일자</th>
          <th className="MemberCustom-th8 textCenter">최근 로그인</th>
        </tr>
      </thead>

      <tbody>
        {searchList?.length !== 0 ? (
          searchList?.map(item => (
            <tr key={item?.user_uid} className="MemberCustom-tr">
              <td className="CheckBox textCenter">
                <Checkbox
                  name="list"
                  value={item?.user_uid}
                  colorScheme="blue"
                  isChecked={checkedItems.includes(item?.user_uid)}
                  onChange={e => CheckEach(e, item?.user_uid)}
                />
              </td>
              <td>{item?.name}</td>
              <td>{item?.email}</td>
              <td className="textCenter">
                {dayjs(item?.create_at).format('YYYY-MM-DD')}
              </td>
              <td className="textCenter">
                {item?.login_at !== null
                  ? dayjs(item?.login_at).format('YYYY-MM-DD')
                  : '기록 없음'}
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td></td>
            <td></td>
            <td>결과가 없습니다</td>
            <td></td>
            <td></td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default GroupDetailTable;
